export enum PathRouteNameEnum {
  public = 'public',
  booking = 'booking',
  confirm = 'confirm',
  thankYou = 'thank-you',
  error = 'error',
}
